/**
 * github_developer.js — GitHub Developer
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Philosophy:
 *   Goal:         ATS-first, developer portfolio feel
 *   Hierarchy:    Skills → Experience → Projects → Education
 *   Divider:      Left accent bar (engineering precision aesthetic)
 *   Density:      Compact — every line earns its space
 *   Typography:   Monospace display name, sans-serif body
 *   Audience:     Software engineers targeting FAANG / product companies
 *
 * Visual Identity:
 *   - Sidebar RIGHT (unlike most templates — forces eye to scan left-to-right)
 *   - Skills rendered as badge grid in sidebar — scannable at a glance
 *   - Projects use cards variant — boxed, githubLink prominent
 *   - Section headers use left-bar divider — feels like code comments
 *   - Compact density — high information per square inch
 */

export const github_developer = {
  id: 'github-developer',
  version: 3,
  renderer: 'enterprise',
  name: 'GitHub Developer',
  layout: 'sidebar-right',
  theme: 'classic-navy',
  density: 'compact',
  sectionDividerStyle: 'left-bar',
  sectionOrder: ['personal-info', 'skills', 'experience', 'projects', 'education', 'certifications'],
  components: {
    header: 'header-split',
    experience: 'experience-compact',
    projects: 'projects-cards',
    skills: 'skills-simple-list',
    education: 'education-sidebar',
  },
  layouts: {
    'sidebar-right': {
      component: 'sidebar-right',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'education', 'certifications'],
        main: ['experience', 'projects'],
      },
      overrides: {
        '--font-family-primary': '"JetBrains Mono", "Fira Code", "Consolas", "Courier New", monospace',
        '--font-family-secondary': '"Inter", "Helvetica Neue", Arial, sans-serif',
        '--color-primary': '#1F2328',
        '--color-secondary': '#24292F',
        '--color-accent': '#2DA44E',
        '--color-text-main': '#1F2328',
        '--color-text-light': '#57606A',
        '--color-border': '#D0D7DE',
        '--color-bg-page': '#FFFFFF',
        '--layout-sidebar-width': '200px',
        '--layout-column-gap': '20px',
        '--layout-sidebar-bg': '#F6F8FA',
        '--layout-sidebar-padding': '12px',
        '--layout-sidebar-border': '1px solid #D0D7DE',
        '--spacing-margin': '20px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '22pt',
    '--weight-display': '700',
    '--heading-weight': '600',
    '--heading-text-transform': 'none',
    '--heading-letter-spacing': '0',
    '--border-thickness-heading': '0',
    '--bullet-style': 'disc',
    '--font-size-heading': '8.5pt',
  },
};

export default github_developer;
